import { render, staticRenderFns } from "./proxy-mobile.vue?vue&type=template&id=3e07fd50&"
import script from "./proxy-mobile.vue?vue&type=script&lang=js&"
export * from "./proxy-mobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports